import { FacebookShareButton, TwitterShareButton } from "next-share";

import {
  FacebookTransparentIcon,
  TwitterIcon,
} from "@/components/data-display/icon";

function SocialShare({ shareAbleLink, className, title }) {
  return (
    <div
      className={`${className} flex flex-row space-x-5  space-y-0 lg:flex-col lg:items-center lg:space-x-0 lg:space-y-5`}
    >
      <p className="text-grayD3">Share</p>

      <FacebookShareButton url={shareAbleLink} hashtag={"#Robodoc"}>
        <FacebookTransparentIcon className="hover:text-primary" />
      </FacebookShareButton>

      <TwitterShareButton url={shareAbleLink} title={title}>
        <TwitterIcon className="hover:text-primary" />
      </TwitterShareButton>
    </div>
  );
}
export default SocialShare;
